import { modalVariants } from "../../../Utils/constants";
import { Phone, Mail, ChevronRight } from "../../../Assets/Icons";

import "./contact-support-modal.scss";

export default function renderContactSupportModal(modalContext) {
  const { updateModalComponent, setModalTitle, setModalVariant, setModalClassName } = modalContext;

  updateModalComponent(ContactSupportModal);
  setModalVariant(modalVariants.formDialog);
  setModalTitle("Contact Support");
  setModalClassName("contact-support-modal");
}

const ContactSupportModal = () => {
  return (
    <div className="modal-dialog-content mb-6">
      <p className="text-base-regular color--mist">
        For help with your utilities setup, reach out to MyUtilities support using the options below.
      </p>
      <a href="tel:+18885544609" className="contact-option-card mb-4">
        <div className="contact-info">
          <div className="icon-container">
            <Phone />
          </div>
          <div className="details">
            <span className="label">Phone</span>
            <span className="value">888-554-4609</span>
          </div>
        </div>
        <div className="chevron">
          <ChevronRight />
        </div>
      </a>
      <a href="mailto:support@myutilities.com" className="contact-option-card">
        <div className="contact-info">
          <div className="icon-container">
            <Mail />
          </div>
          <div className="details">
            <span className="label">Email</span>
            <span className="value">support@myutilities.com</span>
          </div>
        </div>
        <div className="chevron">
          <ChevronRight />
        </div>
      </a>
    </div>
  );
};
